import React, { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import Link from "../core-link"
import PropTypes from "prop-types"
import MenuPointer from "./menu-slider-navbar/svgs/menu-pointer"

const DropdownContainer = styled.div`
  position: absolute;
  left: 30px;
  top: 24px;
`

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  width: 200px;

  border-radius: 8px;
  border: 1px solid #f2f4f7;
  background: var(--White, #fff);
  box-shadow:
    0px 4px 4px 0px rgba(0, 0, 0, 0.25),
    0px 12px 16px -4px rgba(16, 24, 40, 0.08),
    0px -7px 6px -2px rgba(16, 24, 40, 0.03);
`

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 24px;
  border-bottom: 1px solid #eceff3;
`

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
`

const Name = styled.span`
  color: #315254;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const ChevronHolder = styled.div`
  position: absolute;
  right: 24px;
  top: -12px;
  z-index: 10;
`

const MenuItem = styled(Link)`
  display: block;
  text-decoration: none;
  padding: 8px 24px;
  color: #272d37;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;

  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-top: 1px solid #eceff3;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

const NavbarProfilePopup = ({ user, signout, setShowpopup, showPopup }) => {
  const dropdownRef = useRef(null)
  const [isHovered, setIsHovered] = useState(false)
  const timeoutRef = useRef(null)

  const handleSignout = event => {
    event.preventDefault()
    signout()
      .then(result => {
        console.log("signout result =>", result)
      })
      .catch(error => {
        console.log("signout error =>", error)
      })
  }

  useEffect(() => {
    if (!isHovered) {
      timeoutRef.current = setTimeout(() => {
        if (showPopup === 4) {
          setShowpopup(-1)
        }
      }, 2000)
    } else {
      clearTimeout(timeoutRef.current)
    }

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [isHovered, showPopup, setShowpopup])

  return (
    <DropdownContainer
      ref={dropdownRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false)
        setShowpopup(-1)
      }}
    >
      <ChevronHolder>
        <MenuPointer />
      </ChevronHolder>
      <DropdownMenu>
        <ProfileSection>
          <Avatar
            src="https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
            alt="User Avatar"
          />
          <Name>{user.profile.displayName}</Name>
        </ProfileSection>
        <MenuItem to={"/user/profile/"}>My account</MenuItem>
        <MenuItem onClick={handleSignout}>Log out</MenuItem>
      </DropdownMenu>
    </DropdownContainer>
  )
}

NavbarProfilePopup.propTypes = {
  user: PropTypes.object,
  signout: PropTypes.func,
  setShowpopup: PropTypes.func,
  showPopup: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}
export default NavbarProfilePopup
